// extracted by mini-css-extract-plugin
module.exports = {"main_sign":"sign_main_sign__xozDO","upper":"sign_upper__1wKXJ","divide":"sign_divide__1Mu-8","lin":"sign_lin__1yVl9","sig_botm":"sign_sig_botm__2_Oo4"};